import type { MaturityLabel } from "./types";

// Readiness-scale colors — the single source of truth, shared by the maturity
// Likert poll and the Readiness Radar. Index 0..4 => levels 1..5.
export const MATURITY_COLORS = [
  "oklch(62% 0.22 18)", // 1 Ideating
  "oklch(70% 0.19 52)", // 2 Experimenting
  "oklch(62% 0.18 168)", // 3 Optimizing
  "oklch(55% 0.19 250)", // 4 Transforming
  "oklch(52% 0.24 288)", // 5 Leading
] as const;

// Map a 1–5 score to its readiness-scale color using the same band edges as
// maturityLabel(). This is what the radar/score colors should key off of.
export function maturityColor(score: number): string {
  if (score >= 4.5) return MATURITY_COLORS[4];
  if (score >= 3.5) return MATURITY_COLORS[3];
  if (score >= 2.5) return MATURITY_COLORS[2];
  if (score >= 1.5) return MATURITY_COLORS[1];
  return MATURITY_COLORS[0];
}

// Maturity bands from provenance.json / demo:
// <1.5 Ideating · <2.5 Experimenting · <3.5 Optimizing · <4.5 Transforming · >=4.5 Leading
export function maturityLabel(score: number): MaturityLabel {
  if (score >= 4.5) return "Leading";
  if (score >= 3.5) return "Transforming";
  if (score >= 2.5) return "Optimizing";
  if (score >= 1.5) return "Experimenting";
  return "Ideating";
}

export function round1(n: number): number {
  return Math.round(n * 10) / 10;
}

export function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

export function mean(values: number[]): number | null {
  if (!values.length) return null;
  return values.reduce((s, n) => s + n, 0) / values.length;
}

// Color band for a score, matching the demo's heatmap thresholds.
export function heatColor(v: number): string {
  if (v >= 4) return "#dcfce7";
  if (v >= 3) return "#fef9c3";
  if (v >= 2) return "#fed7aa";
  return "#fee2e2";
}

// Score text color used in radar/insights: blue >=3.5, amber >=2.5, red below.
export function scoreColor(v: number): string {
  if (v >= 3.5) return "#0078d4";
  if (v >= 2.5) return "#f59e0b";
  return "#e53e3e";
}
